import type { WorkflowOptions } from '../../types';
import { addContractWorkflow } from './addContractWorkflow';
import { generateAssetStatusWorkflow } from '../generateAssetStatusWorkflows';
import { editContractWorkflow } from './editContract';
export const workflows: WorkflowOptions[] = [
  addContractWorkflow,
  editContractWorkflow,
  ...Object.values(generateAssetStatusWorkflow('contract')),
];

export default workflows;
